/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react';
import difference from 'lodash/difference';
import find from 'lodash/find';
import { observer } from 'src/utils/mobx-react';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { CountryDropdown } from 'src/components/CountryDropdown/CountryDropdown';
import Form from 'src/components/Form/Form';
import DateInputMDY from 'src/components/DateInputMDY/DateInputMDY';
import config from 'src/config';
import { getTranslationFor } from 'src/locale/lang';
import { useCommon } from 'src/AppState/Common';

let mobilePrefixes = config.mobilePrefixes.map((prefix) => {
    return {
        value: `${prefix.prefix },${ prefix.id}`,
        label: prefix.prefix,
        id: prefix.id
    };
}).sort((x, y) => x.label > y.label ? 1 : -1);

class CreateAccountFormInner extends Form {
    static fieldsValidation = {
        email: [ 'email' ],
        title: [ 'required' ],
        firstName: [ 'required', 'alphaSpaces', [ 'maxLength', 50 ] ],
        surname: [ 'required', ['required'], 'surname', [ 'maxLength', 50 ] ],
        birthDate: [ 'required', 'date', 'adult' ],
        country: [ 'required' ],
        currency: [ 'required' ],
        mobilePhone: [ 'required', 'phone' ],
        mobilePrefix: [ 'required' ],
        postCode: [ 'required', 'postcode' ],
        addressLine1: [ 'required', 'address', [ 'maxLength', 50 ] ],
        addressLine2: [ 'address', [ 'maxLength', 50 ] ],
        city: [ 'required', ['required'], 'city', [ 'maxLength', 50 ] ],
        ringFencedFunds: [ 'required' ]
    };

    static fieldsDependentUpon = {
        dayOfBirth: [ 'monthOfBirth' ],
        monthOfBirth: [ 'dayOfBirth', 'yearOfBirth' ],
        yearOfBirth: [ 'monthOfBirth' ]
    };

    UNSAFE_componentWillMount() {
        if (Form.prototype.UNSAFE_componentWillMount) {
            Form.prototype.UNSAFE_componentWillMount.call(this);
        }

        if (this.state.data.country) {
            this.validate('country');
        }
    }

    onSubmit(e) {
        e.preventDefault();
        this.state.data.personalId = null;

        Form.prototype.onSubmit.call(this, e);
    }

    onBlur(name, field) {
        const { onBlur } = this.props;

        if (name === 'country') {
            const countryId = field.target.value;
            if (countryId) {
                const mobilePrefix = config.mobilePrefixes.filter( prefix => prefix.id === countryId );

                if (mobilePrefix.length > 0) {
                    this.state.data.mobilePrefix = `${mobilePrefix[0].prefix },${ mobilePrefix[0].id}`;
                    this.state.data.landlinePrefix = `${mobilePrefix[0].prefix },${ mobilePrefix[0].id}`;
                }
            }
        }
        const error = this.validate(name);

        if (onBlur) {
            onBlur(name, this.state.data[name], this.focused[name], error);
        }

        delete this.focused[name];
    }

    showError(){
        const { errors, debug } = this.props;

        const debugCode = debug?.get('code');
        const debugMessage = debug?.get('message');

        if (debugCode === 'single_license_constraint' && debugMessage !== undefined){
            return debugMessage;
        }

        return errors?.get('program');
    }

    renderForm() {
        const { ringFencedFunds, currencies, contactPreferences } = this.props;
        const countries = config.countries.filter( (country) => !find(config.topCountries, { id: country.id }));

        const topCountriesList = config.topCountries.map((c) => (
            <option key={ `${c.id }-${ c.name.replace(' ', '-')}` } value={ c.id }>{ c.name }</option>
        ));

        const bodyCountriesList = countries.map((c) => (
            <option key={ `${c.id }-${ c.name.replace(' ', '-')}` } value={ c.id }>{ c.name }</option>
        ));


        const currenciesList = currencies.map((c) => (
            <option key={ c } value={ c }>{ c }</option>
        ));

        const bodyMobilePrefix = mobilePrefixes.filter( mobilePrefix => !find(config.topCountries, { id: mobilePrefix.id }) );
        const arrayTopCountrysId = config.topCountries.map( c => c.id );
        const topMobilePrefix = difference(mobilePrefixes, bodyMobilePrefix).sort(function (a, b) {
            return arrayTopCountrysId.indexOf(a.id) > arrayTopCountrysId.indexOf(b.id) ? 1 : -1;
        });
        mobilePrefixes = topMobilePrefix.concat(bodyMobilePrefix);

        return (
            <div>
                <div className='row personal-details-form'>
                    <div className='col-6'>
                        <div className='row'>
                            <div className='col-3'>
                                {
                                    this.getField(
                                        <select
                                            label={ getTranslationFor('USER_TITLE_LABEL') }
                                            { ...this.getFieldParameters('title') }
                                        >
                                            <option />
                                            <option value='mr'>{ getTranslationFor('USER_TITLE_MR_LABEL') }</option>
                                            <option value='mrs'>{ getTranslationFor('USER_TITLE_MRS_LABEL') }</option>
                                            <option value='ms'>{ getTranslationFor('USER_TITLE_MS_LABEL') }</option>
                                            <option value='miss'>{ getTranslationFor('USER_TITLE_MISS_LABEL') }</option>
                                        </select>
                                    )
                                }
                            </div>
                            <div className='col-9'>
                                {
                                    this.getField(
                                        <input type='text'
                                            label='First name'
                                            { ...this.getFieldParameters('firstName') }
                                        />
                                    )
                                }
                            </div>
                        </div>

                        {
                            this.getField(
                                <input type='text'
                                    label='Surname'
                                    { ...this.getFieldParameters('surname') }
                                />
                            )
                        }

                        {
                            this.getField(
                                <DateInputMDY
                                    label='Date of birth'
                                    { ...this.getFieldParameters('birthDate') }
                                />
                            )
                        }

                        <div className='row'>
                            <div className='col-6'>
                                {
                                    this.getField(
                                        <input type='text'
                                            label='Telebetting ID'
                                            { ...this.getFieldParameters('telebettingId') }
                                        />
                                    )
                                }
                            </div>
                            <div className='col-6'>
                                {
                                    this.getField(
                                        <input type='text'
                                            label='Telebetting password'
                                            { ...this.getFieldParameters('telebettingPassword') }
                                        />
                                    )
                                }
                            </div>
                        </div>

                        {
                            this.getField(
                                <select
                                    label='Currency'
                                    { ...this.getFieldParameters('currency') }
                                >
                                    <option />
                                    { currenciesList }
                                </select>
                            )
                        }

                        {
                            this.getField(
                                <input type='email'
                                    label='E-mail'
                                    { ...this.getFieldParameters('email') }
                                />
                            )
                        }

                        <div className='row'>
                            <div className='col-4'>
                                {
                                    this.getField(
                                        <CountryDropdown
                                            options={ mobilePrefixes }
                                            label='Mobile prefix'
                                            { ...this.getFieldParameters('mobilePrefix') }
                                        />
                                    )
                                }
                            </div>
                            <div className='col-8'>
                                {
                                    this.getField(
                                        <input
                                            type='text'
                                            pattern='[0-9 ]+'
                                            label='Mobile number'
                                            { ...this.getFieldParameters('mobilePhone') }
                                        />
                                    )
                                }
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-4'>
                                {
                                    this.getField(
                                        <CountryDropdown
                                            options={ mobilePrefixes }
                                            label='Landline prefix'
                                            { ...this.getFieldParameters('landlinePrefix') }
                                        />
                                    )
                                }
                            </div>
                            <div className='col-8'>
                                {
                                    this.getField(
                                        <input
                                            type='text'
                                            pattern='[0-9 ]+'
                                            label='Landline number'
                                            { ...this.getFieldParameters('landlinePhone') }
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                        {
                            this.getField(
                                <select
                                    label='Country'
                                    { ...this.getFieldParameters('country') }
                                >
                                    <option />
                                    <optgroup>
                                        { topCountriesList }
                                    </optgroup>
                                    <optgroup label='_________________________'>
                                        { bodyCountriesList }
                                    </optgroup>
                                </select>
                            )
                        }

                        {
                            this.getField(
                                <input type='text'
                                    label='Postcode'
                                    { ...this.getFieldParameters('postCode') }
                                />
                            )
                        }

                        {
                            this.getField(
                                <input type='text'
                                    label='Address line 1'
                                    { ...this.getFieldParameters('addressLine1') }
                                />
                            )
                        }

                        {
                            this.getField(
                                <input type='text'
                                    label='Address line 2'
                                    { ...this.getFieldParameters('addressLine2') }
                                />
                            )
                        }

                        {
                            this.getField(
                                <input type='text'
                                    label='Town/City'
                                    { ...this.getFieldParameters('city') }
                                />
                            )
                        }

                        {
                            this.getField(
                                <input type='text'
                                    label='County'
                                    { ...this.getFieldParameters('county') }
                                />
                            )
                        }

                        {contactPreferences.newMarketing === true ? null : (
                        <>
                            <h2>Contact Preferences</h2>
                            {contactPreferences.preferences.map( ( contactPreference ) => this.getCheckbox( `contactPreferences.${contactPreference}`, contactPreference, contactPreference ) )}
                        </>
                        )}
                    </div>
                </div>

                { ringFencedFunds === true ?
                    this.getCheckbox(
                        'ringFencedFunds',
                        'Confirm customer is aware of ringfenced funds legislation'
                    ) : null
                }

                { this.getBasicError(this.showError()) }

                <div className='buttons'>
                    <button className='btn btn-primary' type='submit'>
                        Create account
                    </button>
                </div>
            </div>
        );
    }
}

export const CreateAccountForm = observer('CreateAccountForm', (props) => {

    const common = useCommon();
    const configState = ConfigState.get(common);

    const { showRingFencedFunds, currencies, contactPreferences } = configState.config;
    const { errors, debug, onSubmit } = props;


        return (
            <CreateAccountFormInner
                errors={ errors }
                debug={ debug }
                onSubmit={ onSubmit }
                ringFencedFunds={ showRingFencedFunds }
                currencies={currencies}
                contactPreferences={contactPreferences}
            />
        );
});
